import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PrivateRoute from "../Components/Authentication/privateRoute";
import ListAdmins from "../Components/Manage Admins/listAdmins";
import AddAdmins from "../Components/Manage Admins/addAdmins";
import EditAdmins from "../Components/Manage Admins/editAdmins";
import ViewAdmin from "../Components/Manage Admins/ViewAdmin";

const AdminRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  return (
    <div>
      <Routes>
        <Route path="/">
          <Route element={<PrivateRoute />}>
            <Route
              path="/manage_admins"
              element={<ListAdmins></ListAdmins>}
            ></Route>
            <Route
              path="/manage_admins/add"
              element={canAdd ? <AddAdmins /> : <Navigate to="/manage_admins" replace />}
            ></Route>
            <Route
              path="/manage_admins/edit/:id"
              element={canEdit ? <EditAdmins /> : <Navigate to="/manage_admins" replace />}
            ></Route>
            <Route
              path="/manage_admins/view/:id"
              element={<ViewAdmin />}
            ></Route>
          </Route>
        </Route>
      </Routes>
    </div>
  );
};

export default AdminRoutes;
